import React from "react";
import Input from "../../../components/controls/Input";
import SelectMenu from "../../../components/controls/SelectMenu";
import { DropdownOption } from "../employeeProductionTypes";

type Props = {
  lots: DropdownOption[];
  selectedLot: DropdownOption | null;
  barcode: string;
  productionLoading: boolean;
  barcodeLoading: boolean;
  onSelectProduction: (lot: DropdownOption) => void;
  onBarcodeChange: (barcode: string) => void;
  onScan: (barcode: string) => void;
};

export function ProductionScanForm({
  lots,
  selectedLot,
  barcode,
  productionLoading,
  barcodeLoading,
  onSelectProduction,
  onBarcodeChange,
  onScan,
}: Props) {
  return (
    <div className="space-y-5">
      <SelectMenu
        name="lot_number"
        options={lots}
        title="Lot Numbers"
        value={selectedLot}
        disabled={productionLoading}
        useOptionValue={false}
        onValueChange={(value: DropdownOption | null) => {
          if (value) onSelectProduction(value);
        }}
      />

      {selectedLot && (
        <Input
          label="Barcode Scanner"
          name="scanned_assembly_barcode"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            onBarcodeChange(event.target.value)
          }
          value={barcode}
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Enter") onScan(event.currentTarget.value);
          }}
          disabled={barcodeLoading || productionLoading}
          labelOn={true}
          type="text"
          className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-1 shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
        />
      )}
    </div>
  );
}
